import React from 'react';
import styles from '../../styles/home.module.css';

function SectionAbout() {
    return (
        <section className={styles.SectionAbout} id="about">
            <div className={styles.InNew}>
                <h2>Vzami zdravje v svoje roke</h2>
                <div className={styles.CardsAbout}>
                    <div className={styles.CardAbout}>
                        <div className={styles.InCardAbout}>
                            <img className={styles.Image} src={require('../../icons/write.png')} alt="Photography" />
                        </div>
                        <h5>Zapiši vse podatke</h5>
                        <p>Aplikacija med drugim omogoča zapisovanje 
                        zdravstvenih podatkov, ki si jih lahko
                        izmerite doma, ter še mnogo več.</p>
                    </div>
                    <div className={styles.CardAbout}>
                        <div className={styles.InCardAbout}>
                            <img className={styles.Image} src={require('../../icons/show.png')} alt="Photography" />
                        </div>
                        <h5>Pokaži komurkoli</h5>
                        <p>Vaše podatke boste lahko pokazali 
                        osebnemu zdravniku ali drugi izbrani osebi.</p>
                    </div>
                    <div className={styles.CardAbout}>
                        <div className={styles.InCardAbout}>
                            <img className={styles.Image} src={require('../../icons/health.png')} alt="Photography" />
                        </div>
                        <h5>Ostani zdrav</h5>
                        <p>Redno spremljanje telesnih
                        meritev, lahko pripomore tudi k
                        izboljšanju vašega zdravja.</p>
                    </div>
                </div>
            </div>
        </section>
    )
}
export default SectionAbout;